export default __webpack_public_path__ + "static/media/1633.18f2ee3f.png";